import { useCallback } from "react";

import { useGoatCounter } from "./useGoatCounter";
import { useSimpleAnalyticsEvent } from "./useSimpleAnalyticsEvent";

export const useCountEvent = () => {
  const goatCounter = useGoatCounter();
  const simpleAnalyticsEvent = useSimpleAnalyticsEvent();
  return useCallback(
    (eventName: string, extraPath?: string) => {
      goatCounter(eventName, extraPath);
      simpleAnalyticsEvent(eventName);
    },
    [goatCounter, simpleAnalyticsEvent]
  );
};
